import request from '../../../shared/request'

export function getLeadEstimates(lead_id) {
  return request(`/lead/estimates/${lead_id}/`)
}

export function getEstimateSections(estimate_id) {
  return request(`/lead/estimates/${estimate_id}/section`)
}

export function getEstimateItems(estimate_id) {
  return request(`/lead/estimates/${estimate_id}/item`)
}

export function createLeadEstimate(payload) {
  return request(`/lead/estimates/${payload.leadId}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateLeadEstimate(payload) {
  return request(`/lead/estimates/${payload.estimateId}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteLeadEstimate(payload) {
  return request(`/lead/estimates/${payload.estimate_id}/?leadId=${payload.leadId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/lead/estimates.js